/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Notes from './Notes/index'
import NotesInput from './NotesInput/index'
import Options from './Options/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/AdditionalOptions/Content"
  
}) {
  return (<React.Fragment
>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
<NotesInput
  viewPath={`${viewPath}/NotesInput`}
/>
{children}
</React.Fragment>)
}